import { Component, Renderer, ElementRef, OnInit, AfterViewInit } from '@angular/core';
import { CookieService } from 'angular2-cookie/core';
import { ActivatedRoute, Router, NavigationStart, NavigationEnd, Params } from '@angular/router';
import { Location } from '@angular/common';
import { isBrowser, isNode } from 'angular2-universal';
import { ConfigService } from '../shared/config.service';
import { UtilsService } from '../shared/utils.service';
import { IntlService } from '../shared/intl.service';
import { CartService } from './cart.service';

declare var $: any;
declare let ga: Function;

@Component({
    template: require('./partials/root.html')
})
export class FrontRootComponent implements OnInit, AfterViewInit {

    public nodeLoading = true;
    public currentYear; 

    dropDownMenuElement: any;
    gaActive: boolean = true; // for dev
    agreesOnCookiePolicy: boolean = false;

    constructor(public config: ConfigService, public intl: IntlService, private cookieService: CookieService, public cartService: CartService, private location: Location, private route: ActivatedRoute, private router: Router, private elementRef: ElementRef, private renderer: Renderer, public utils: UtilsService) {
        this.currentYear = utils.currentYear();
    } 

    isCurrent(link){
        return this.location.path().indexOf(link)>-1;
    }

    getCookieConsent(){
        let cookie = this.cookieService.getObject('cookie-consent');
        if(cookie!=undefined && cookie)
            return true;
        return false;
      }

    onActivate(e) {
        // language check
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                let lang = this.utils.getLanguageByUrl(this.location.path());
                if(lang && lang.length==2 && this.config.data.APP.LANGUAGES.SUPPORTED.indexOf(lang)==-1) 
                    this.router.navigate([this.config.data.APP.LANGUAGES.PREFERRED,'page-not-found']);
            }
        });
        if (isBrowser) {
            // Google Analytics
            if (this.gaActive && this.agreesOnCookiePolicy) {
                ga('set', 'page', this.location.path());
                ga('send', 'pageview');
                //console.log(this.location.path());
            }
            // UI adjustments
            this.router.events.subscribe((evt) => {
                if (evt instanceof NavigationEnd) {
                    window.scrollTo(0, 0);
                }
            });
        }
    }

    ngOnInit() {
        if (isBrowser){
            this.agreesOnCookiePolicy = this.getCookieConsent();
            this.nodeLoading = false;
            // dropdown-menu to be restored to normal
            this.dropDownMenuElement = this.elementRef.nativeElement.querySelector('.dropdown-menu');
            // need to reload for mouseover menu like the cart
            this.utils.loadScripts(["/resources_front/assets/custom/main-bundle.js"], this.elementRef.nativeElement);
        }
    }

    ngAfterViewInit() {
        if (isBrowser) {
            //Click event to scroll to top
            $('.scrollToTop').click(function () {
                $('html, body').animate({
                    scrollTop: 0
                }, 1000);
                return false;
            });

        }
    }

    onSearchClick(target: string, language: string) {
        this.utils.lNavigate(target, language, this.route.parent);
        if (isBrowser){
            setTimeout(() => {
                $('html, body').animate({
                    scrollTop: this.utils.getElementPosition('#content-start', 20, -20)
                }, 1000);
                $('#search-box').focus();
            }, 300);
        }
    }

    onMenuClick(target: string, language: string) {
        if (isBrowser) {
            if(this.utils.isMobile())
                $('.navbar-collapse').collapse("hide");
            // dropdown-menu to be hidden
            if(this.dropDownMenuElement != null){
                this.renderer.setElementClass(this.dropDownMenuElement, 'hidden', true);
                setTimeout(() => {
                    this.renderer.setElementClass(this.dropDownMenuElement, 'hidden', false);
                }, 1000);
            }

        }
        // nav
        //this.router.navigate([target], {relativeTo: this.route.parent});
        this.utils.lNavigate(target, language, this.route.parent);
    }

} 


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/root.component.ts